import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer
} from 'recharts';

const COLORS = [
  '#e94f5f', '#fb7a2a', '#f6c64c', '#53be73',
  '#3796e5', '#735fd5', '#08acc4', '#625f8f',
  '#db4a9d', '#5372d9', '#23b690', '#adbf3f',
  '#ff6f54', '#ffa751', '#53d4b0', '#7389f3'
];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;
  const { name, value, color } = payload[0];
  return (
    <div style={{
      background: 'rgba(17, 28, 48, 0.94)',
      border: '1px solid rgba(110, 137, 178, 0.45)',
      borderRadius: 10,
      padding: '9px 12px',
      color: '#d8e4f8',
      fontSize: 12
    }}>
      <strong style={{ color }}>{name}</strong>: {value}
    </div>
  );
};

export default class AppointmentPieChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [], loading: true };
  }

  componentDidMount() {
    fetch('/api/appointments/hospitals.json')
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(data => this.setState({ data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderLoading() {
    return (
      <div style={{ height: 300, padding: '10px 0' }}>
        <Skeleton height={260} borderRadius={14} />
      </div>
    );
  }

  renderChart() {
    const { data } = this.state;
    // Map Nivo format {id, label, value} to Recharts {name, value}, skip zeros
    const chartData = data
      .filter(item => item.value > 0)
      .map(item => ({
        name: item.label || item.id,
        value: item.value
      }));

    if (chartData.length === 0) {
      return (
        <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8998b1' }}>
          No data available
        </div>
      );
    }

    return (
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="46%"
            innerRadius={52}
            outerRadius={95}
            paddingAngle={1.5}
            stroke="none"
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    );
  }

  render() {
    return (
      <div>
        {this.state.loading ? this.renderLoading() : this.renderChart()}
      </div>
    );
  }
}
